/* eslint-disable unicorn/no-fn-reference-in-iterator */
//
// CachedDOMMeasurement
//

/** Given a CSS pixel string value such as "100px", return an integer such as 100. */
var pxToNum = function pxToNum(cssValue) {
  return Number.parseInt(cssValue || '0', 10);
};
/**
 * Given a css property name, and an element's CSSStyleDeclaration, retrieve the pixel value of that
 * property as a number.
 * @param cssProp - the string name of a CSS Property
 * @param style - style object retrieved from getComputedStyle()
 */


var pixelsFor = function pixelsFor(cssProp, style) {
  return pxToNum(style.getPropertyValue(cssProp));
};

export { pixelsFor };
